import { Component, OnInit } from '@angular/core';

import { UserService } from '../../../../shared/services/user/user.service';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { DropdownBaseComponent } from '../dropdown-base.component';
import { DropDownService } from '../dropdown.service';

@Component({
  selector: 'ngx-notification-type-dropdown',
  templateUrl: '../template-dropdown.html'
})
export class NotificationTypeDropdownComponent extends DropdownBaseComponent implements OnInit {

  constructor(
    private readonly dropdownService: DropDownService,
    protected readonly translatorService: TranslatorService
  ) {
    super(translatorService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.dropDownSettings = this.dropdownService.getConfiguration(this.singleSelection);
    this.itemsData = [
      { id: 'not_notification', name: this.translatorService.trans('dropdown.notificationDeliveryMethod.not_notification') },
      { id: 'email', name:  this.translatorService.trans('dropdown.notificationDeliveryMethod.email') },
      { id: 'push', name:  this.translatorService.trans('dropdown.notificationDeliveryMethod.push') },
      { id: 'both', name:  this.translatorService.trans('dropdown.notificationDeliveryMethod.both') }
    ];
  }

}
